import React, { useEffect, useState, useRef, useMemo } from "react";
import { Box } from "@material-ui/core";
import { convertValuesFM } from "../../../shared-resources/utils";
import { PaginationData } from "../../../common-components/PaginationData";

export const bindRevenue = ({
  revenueBind,
  psrHeaders,
  handleScrollTable,
  revenuTableRef,
  sortOrder,
  filteredRevenue,
  setFilteredRevenue,
}) => {
  if (
    revenueBind &&
    revenueBind.psrClinData &&
    revenueBind.psrClinData.length
  ) {
    const monthsHeader = [];

    psrHeaders?.map((res) => {
      monthsHeader.push(res);
    });

    const updatedRevenueData = filteredRevenue.map((item) => {
      const updatedItem = { ...item };
      const monthMap = {};

      (item.monthExpenseDetail || []).forEach((month) => {
        monthMap[month.monthYear] = month;
      });

      const headerLength = psrHeaders ? psrHeaders.length + 5 : 5;
      const rearrangedMonthDetail = sortOrder.map((month) =>
        monthMap[month] ? monthMap[month] : { expense: "", monthYear: month },
      );

      // Ensure the length matches header
      if (rearrangedMonthDetail.length < headerLength) {
        const defaultMonthItems = Array(
          headerLength - rearrangedMonthDetail.length,
        )
          .fill()
          .map(() => ({ expense: "" }));
        rearrangedMonthDetail.push(...defaultMonthItems);
      } else if (rearrangedMonthDetail.length > headerLength) {
        rearrangedMonthDetail.splice(headerLength);
      }

      updatedItem.monthExpenseDetail = rearrangedMonthDetail;
      return updatedItem;
    });

    const monthMapTotal = {};
    (revenueBind.totalRevenue.monthExpenseDetail || []).forEach((month) => {
      monthMapTotal[month.monthYear] = month;
    });

    let updatedTotalPsr = sortOrder.map((month) =>
      monthMapTotal[month]
        ? monthMapTotal[month]
        : { expense: "", monthYear: month },
    );
    const headerLength = psrHeaders ? psrHeaders.length + 5 : 5;
    // Match header length
    if (updatedTotalPsr.length < headerLength) {
      const defaultMonthItems = Array(headerLength - updatedTotalPsr.length)
        .fill()
        .map(() => ({ expense: "" }));
      updatedTotalPsr = [...updatedTotalPsr, ...defaultMonthItems];
    } else if (updatedTotalPsr.length > headerLength) {
      updatedTotalPsr = updatedTotalPsr.slice(0, headerLength);
    }

    const monthMapAdjustment = {};
    (revenueBind.forecastRevenueAdjustment.monthExpenseDetail || []).forEach(
      (month) => {
        monthMapAdjustment[month.monthYear] = month;
      },
    );

    let updatedAdjustmentPsr = sortOrder.map((month) =>
      monthMapAdjustment[month]
        ? monthMapAdjustment[month]
        : { expense: "", monthYear: month },
    );
    // Match header length
    if (updatedAdjustmentPsr.length < headerLength) {
      const defaultMonthItems = Array(
        headerLength - updatedAdjustmentPsr.length,
      )
        .fill()
        .map(() => ({ expense: "" }));
      updatedAdjustmentPsr = [...updatedAdjustmentPsr, ...defaultMonthItems];
    } else if (updatedAdjustmentPsr.length > headerLength) {
      updatedAdjustmentPsr = updatedAdjustmentPsr.slice(0, headerLength);
    }

    return (
      <Box>
        <Box display="flex" flexDirection="row">
          <Box
            style={{
              boxShadow: "0px 3px 6px #00000029",
              width: "500px",
              marginRight: "8px",
            }}
          >
            <table className="firstTableFin" cellPadding={0} cellSpacing={0}>
              <thead>
                <tr>
                  <th style={{ minWidth: "270px", maxWidth: "270px" }}>
                    Project
                  </th>
                  <th style={{ minWidth: "230px", maxWidth: "230px" }}>
                    Project Name
                  </th>
                </tr>
              </thead>
              <tbody>
                {filteredRevenue.map((item, i) => (
                  <tr key={i}>
                    <td
                      style={{ minWidth: "270px", maxWidth: "270px" }}
                      title={item.project}
                    >
                      {item.project}
                    </td>
                    <td
                      style={{ minWidth: "230px", maxWidth: "230px" }}
                      title={item.projectName}
                    >
                      {item.projectName}
                    </td>
                  </tr>
                ))}
                <tr>
                  <td
                    colSpan={6}
                    style={{
                      textAlign: "right",
                      fontWeight: 600,
                      paddingRight: "8px",
                    }}
                  >
                    Forecast Adjustment
                  </td>
                </tr>
                <tr>
                  <td
                    colSpan={6}
                    style={{
                      textAlign: "right",
                      fontWeight: 600,
                      paddingRight: "8px",
                    }}
                  >
                    Total Revenue
                  </td>
                </tr>
              </tbody>
            </table>
          </Box>
          <Box
            ref={revenuTableRef}
            style={{ overflowX: "auto", boxShadow: "0px 3px 6px #00000029" }}
            onScroll={() => handleScrollTable("revenueTable")}
          >
            <Box display="flex" flexDirection="row">
              <Box
                style={{
                  boxShadow: "0px 3px 6px #00000029",
                  marginRight: "8px",
                }}
              >
                <table
                  className="secondTableFin"
                  cellPadding={0}
                  cellSpacing={0}
                  width={"1500"}
                >
                  <thead>
                    <tr>
                      <th
                        rowSpan={1}
                        style={{ minWidth: "120px", maxWidth: "120px" }}
                      ></th>
                      <th
                        rowSpan={1}
                        style={{ minWidth: "120px", maxWidth: "120px" }}
                      ></th>
                      <th
                        rowSpan={1}
                        style={{ minWidth: "120px", maxWidth: "120px" }}
                      ></th>
                      <th
                        rowSpan={1}
                        style={{ minWidth: "120px", maxWidth: "120px" }}
                      ></th>
                      <th
                        rowSpan={1}
                        style={{ minWidth: "120px", maxWidth: "120px" }}
                      ></th>
                      {monthsHeader.map((item, i) => (
                        <th
                          rowSpan={1}
                          key={i}
                          className="centerAlignedHeaderLeftBorder"
                          style={{
                            minWidth: "100px",
                            maxWidth: "100px",
                            padding: "0px 10px",
                            textAlign: "center",
                          }}
                        >
                          {item.heading}
                        </th>
                      ))}
                    </tr>
                    <tr>
                      <th
                        rowSpan={1}
                        style={{
                          minWidth: "120px",
                          maxWidth: "120px",
                          padding: "0px 20px",
                          textAlign: "center",
                        }}
                        className="actualHeaderCost"
                      >
                        ITD Actuals till 2024
                      </th>
                      <th
                        rowSpan={1}
                        style={{
                          minWidth: "120px",
                          maxWidth: "120px",
                          padding: "0px 10px",
                          textAlign: "center",
                        }}
                        className="actualHeaderCost"
                      >
                        ITD Actuals from 2025
                      </th>
                      <th
                        rowSpan={1}
                        style={{
                          minWidth: "120px",
                          maxWidth: "120px",
                          padding: "0px 10px",
                          textAlign: "center",
                        }}
                        className="forecastHeaderCost"
                      >
                        Forecast (ETC)
                      </th>
                      <th
                        rowSpan={1}
                        className="actualHeaderCost"
                        style={{
                          minWidth: "120px",
                          maxWidth: "120px",
                          padding: "0px 10px",
                          textAlign: "center",
                        }}
                      >
                        Actuals + Forecast (EAC)
                      </th>
                      <th
                        rowSpan={1}
                        style={{
                          minWidth: "120px",
                          maxWidth: "120px",
                          padding: "0px 10px",
                          textAlign: "center",
                        }}
                        className="forecastHeaderCost"
                      >
                        Total for Year
                      </th>
                      {monthsHeader.map((item, i) => (
                        <>
                          <th
                            rowSpan={1}
                            className={
                              item.type === "Actual"
                                ? "actualHeaderCost"
                                : "forecastHeaderCost"
                            }
                            style={{
                              minWidth: "100px",
                              maxWidth: "100px",
                              padding: "0px 10px",
                              textAlign: "center",
                            }}
                          >
                            {item.type}
                          </th>
                        </>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {updatedRevenueData.map((item, i) => (
                      <tr key={i}>
                        {item.monthExpenseDetail.map((monthItem, j) => (
                          <>
                            <td
                              style={{
                                minWidth: "120px",
                                maxWidth: "120px",
                                textAlign: "center",
                              }}
                              title={monthItem.expense}
                            >
                              {monthItem.expense === ""
                                ? ""
                                : `${convertValuesFM(monthItem.expense)}`}
                            </td>
                          </>
                        ))}
                      </tr>
                    ))}
                    <tr className="totalDataRow">
                      {updatedAdjustmentPsr.map((item, i) => (
                        <>
                          <td
                            style={{
                              minWidth: "120px",
                              maxWidth: "120px",
                              textAlign: "center",
                              color: "#000",
                            }}
                            title={item.expense}
                          >
                            {item.expense === ""
                              ? ""
                              : `${convertValuesFM(item.expense)}`}
                          </td>
                        </>
                      ))}
                    </tr>
                    <tr className="totalDataRow">
                      {updatedTotalPsr.map((item, i) => (
                        <>
                          <td
                            style={{
                              minWidth: "120px",
                              maxWidth: "120px",
                              textAlign: "center",
                              color: item.isThresholdReached ? "red" : "#000",
                            }}
                            title={item.expense}
                          >
                            {item.expense === ""
                              ? ""
                              : `${convertValuesFM(item.expense)}`}
                          </td>
                        </>
                      ))}
                    </tr>
                  </tbody>
                </table>
              </Box>
            </Box>
          </Box>
        </Box>

        <PaginationData
          data={revenueBind.psrClinData || []}
          setFilteredData={setFilteredRevenue}
          title="REVENUE"
        />
      </Box>
    );
  } else {
    return (
      <div
        style={{
          textAlign: "center",
          fontWeight: 600,
          background: "#fff",
          padding: "24px 0",
        }}
      >
        No Data
      </div>
    );
  }
};

// export const bindRevenueTotal = ({
//   revenueBind,
//   psrHeaders,
//   revenueTotalRef,
//   handleScrollTable,
//   revenuTableRef,
//   sortOrder,
// }) => {
//   if (!revenueBind) return null;

//   const headerLength = psrHeaders ? psrHeaders.length + 5 : 5;

//   const buildAligned = (monthExpenseDetail) => {
//     const monthMap = {};
//     (monthExpenseDetail || []).forEach((m) => {
//       monthMap[m.monthYear] = m;
//     });

//     let aligned = sortOrder.map((month) =>
//       monthMap[month] ? monthMap[month] : { expense: "", monthYear: month },
//     );

//     if (aligned.length < headerLength) {
//       aligned = [
//         ...aligned,
//         ...Array(headerLength - aligned.length)
//           .fill()
//           .map(() => ({ expense: "" })),
//       ];
//     } else if (aligned.length > headerLength) {
//       aligned = aligned.slice(0, headerLength);
//     }
//     return aligned;
//   };

//   const updatedAdjustmentPsr = buildAligned(
//     revenueBind.forecastRevenueAdjustment?.monthExpenseDetail,
//   );
//   const updatedTotalPsr = buildAligned(
//     revenueBind.totalRevenue?.monthExpenseDetail,
//   );

//   return (
//     <Box display="flex" flexDirection="row">
//       <Box
//         style={{
//           boxShadow: "0px 3px 6px #00000029",
//           width: "500px",
//           marginRight: "8px",
//         }}
//       >
//         <table className="firstTableFin" cellPadding={0} cellSpacing={0}>
//           <tbody>
//             <tr>
//               <td style={{ minWidth: "270px", maxWidth: "270px" }}></td>
//               <td
//                 colSpan={6}
//                 style={{
//                   textAlign: "right",
//                   fontWeight: 600,
//                   paddingRight: "8px",
//                   minWidth: "230px",
//                   maxWidth: "230px",
//                 }}
//               >
//                 Forecast Adjustment
//               </td>
//             </tr>
//             <tr>
//               <td
//                 colSpan={6}
//                 style={{
//                   textAlign: "right",
//                   fontWeight: 600,
//                   paddingRight: "8px",
//                 }}
//               >
//                 Total Revenue
//               </td>
//             </tr>
//           </tbody>
//         </table>
//       </Box>

//       <Box
//         ref={revenueTotalRef}
//         style={{ overflowX: "auto", boxShadow: "0px 3px 6px #00000029" }}
//         onScroll={() => handleScrollTable("revenueTotal")}
//       >
//         <table
//           className="secondTableFin"
//           cellPadding={0}
//           cellSpacing={0}
//           width={"1500"}
//         >
//           <tbody>
//             <tr className="totalDataRow">
//               {updatedAdjustmentPsr.map((item, i) => (
//                 <td
//                   key={i}
//                   style={{
//                     minWidth: "120px",
//                     maxWidth: "120px",
//                     textAlign: "center",
//                     color: "#000",
//                   }}
//                   title={item.expense}
//                 >
//                   {item.expense === ""
//                     ? ""
//                     : `${convertValuesFM(item.expense)}`}
//                 </td>
//               ))}
//             </tr>
//             <tr className="totalDataRow">
//               {updatedTotalPsr.map((item, i) => (
//                 <td
//                   key={i}
//                   style={{
//                     minWidth: "120px",
//                     maxWidth: "120px",
//                     textAlign: "center",
//                     color: item.isThresholdReached ? "red" : "#000",
//                   }}
//                   title={item.expense}
//                 >
//                   {item.expense === ""
//                     ? ""
//                     : `${convertValuesFM(item.expense)}`}
//                 </td>
//               ))}
//             </tr>
//           </tbody>
//         </table>
//       </Box>
//     </Box>
//   );
// };

const NoData = () => (
  <div
    style={{
      textAlign: "center",
      fontWeight: 600,
      background: "#fff",
      padding: "24px 0",
    }}
  >
    No Data
  </div>
);
export const bindDirectLabor = ({
  directLaborCostBind,
  psrHeaders,
  handleScrollTable,
  directLabourRef,
  sortOrder,
  filteredDirectLabor,
  setFilteredDirectLabor,
}) => {
  if (
    directLaborCostBind &&
    directLaborCostBind.psrClinData &&
    directLaborCostBind.psrClinData.length > 0
  ) {
    const monthsHeader = [];

    psrHeaders?.map((res) => {
      monthsHeader.push(res);
    });

    const updatedRevenueData = filteredDirectLabor.map((item) => {
      const updatedItem = { ...item };
      const monthMap = {};

      // Build a map for fast lookup
      (item.monthExpenseDetail || []).forEach((month) => {
        monthMap[month.monthYear] = month;
      });

      // Reconstruct array based on sortOrder, filling in missing months with empty values
      const rearrangedMonthDetail = sortOrder.map((month) =>
        monthMap[month] ? monthMap[month] : { expense: "", monthYear: month },
      );

      // Add filler if headers exceed
      const headerLength = psrHeaders ? psrHeaders.length + 5 : 5;
      if (rearrangedMonthDetail.length < headerLength) {
        const defaultMonthItems = Array(
          headerLength - rearrangedMonthDetail.length,
        )
          .fill()
          .map(() => ({ expense: "" }));
        rearrangedMonthDetail.push(...defaultMonthItems);
      } else if (rearrangedMonthDetail.length > headerLength) {
        rearrangedMonthDetail.splice(headerLength);
      }

      updatedItem.monthExpenseDetail = rearrangedMonthDetail;
      return updatedItem;
    });

    const monthMapTotal = {};
    (directLaborCostBind.totalDirectLaborCost.monthExpenseDetail || []).forEach(
      (month) => {
        monthMapTotal[month.monthYear] = month;
      },
    );

    let updatedTotalPsr = sortOrder.map((month) =>
      monthMapTotal[month]
        ? monthMapTotal[month]
        : { expense: "", monthYear: month },
    );
    const headerLength = psrHeaders ? psrHeaders.length + 5 : 5;
    // Pad or slice to match header length
    if (updatedTotalPsr.length < headerLength) {
      const defaultMonthItems = Array(headerLength - updatedTotalPsr.length)
        .fill()
        .map(() => ({ expense: "" }));
      updatedTotalPsr = [...updatedTotalPsr, ...defaultMonthItems];
    } else if (updatedTotalPsr.length > headerLength) {
      updatedTotalPsr = updatedTotalPsr.slice(0, headerLength);
    }

    return (
      <Box>
        <Box display="flex" flexDirection="row">
          <Box
            style={{
              boxShadow: "0px 3px 6px #00000029",
              width: "500px",
              marginRight: "8px",
            }}
          >
            <table className="firstTableFin" cellPadding={0} cellSpacing={0}>
              <tbody>
                {filteredDirectLabor.map((item, i) => (
                  <tr key={i}>
                    <td
                      style={{ minWidth: "270px", maxWidth: "270px" }}
                      title={item.project}
                    >
                      {item.project}
                    </td>
                    <td
                      style={{ minWidth: "230px", maxWidth: "230px" }}
                      title={item.projectName}
                    >
                      {item.projectName}
                    </td>
                  </tr>
                ))}

                <tr>
                  <td
                    colSpan={6}
                    style={{
                      textAlign: "right",
                      fontWeight: 600,
                      paddingRight: "8px",
                    }}
                  >
                    Total Direct Labor
                  </td>
                </tr>
              </tbody>
            </table>
          </Box>
          <Box
            ref={directLabourRef}
            style={{ overflowX: "auto", boxShadow: "0px 3px 6px #00000029" }}
            onScroll={() => handleScrollTable("directLabor")}
          >
            <Box display="flex" flexDirection="row">
              <Box
                style={{
                  boxShadow: "0px 3px 6px #00000029",
                  marginRight: "8px",
                }}
              >
                <table
                  className="secondTableFin"
                  cellPadding={0}
                  cellSpacing={0}
                  width={"1500"}
                >
                  <tbody>
                    {updatedRevenueData.map((item, i) => (
                      <tr key={i}>
                        {item.monthExpenseDetail.map((monthItem, j) => (
                          <>
                            <td
                              style={{
                                minWidth: "120px",
                                maxWidth: "120px",
                                textAlign: "center",
                              }}
                              title={monthItem.expense}
                            >
                              {monthItem.expense === ""
                                ? ""
                                : `${convertValuesFM(monthItem.expense)}`}
                            </td>
                          </>
                        ))}
                      </tr>
                    ))}
                    <tr className="totalDataRow">
                      {updatedTotalPsr.map((item, i) => (
                        <>
                          <td
                            style={{
                              minWidth: "120px",
                              maxWidth: "120px",
                              textAlign: "center",
                            }}
                            title={item.expense}
                          >
                            {item.expense === ""
                              ? ""
                              : `${convertValuesFM(item.expense)}`}
                          </td>
                        </>
                      ))}
                    </tr>
                  </tbody>
                </table>
              </Box>
            </Box>
          </Box>
        </Box>

        <PaginationData
          data={directLaborCostBind.psrClinData || []}
          setFilteredData={setFilteredDirectLabor}
          title="direct labor cost"
        />
      </Box>
    );
  } else {
    return (
      <div
        style={{
          textAlign: "center",
          fontWeight: 600,
          background: "#fff",
          padding: "24px 0",
        }}
      >
        No Data
      </div>
    );
  }
};
export const bindSubcontractor = ({
  subcontractorBind,
  psrHeaders,
  handleScrollTable,
  subcontractorRef,
  sortOrder,
  filteredSubcontractor,
  setFilteredSubcontractor,
}) => {
  if (
    subcontractorBind &&
    subcontractorBind.psrClinData &&
    subcontractorBind.psrClinData.length > 0
  ) {
    const monthsHeader = [];

    psrHeaders?.map((res) => {
      monthsHeader.push(res);
    });

    // Function to map and align data based on sortOrder
    const mapBySortOrder = (arr, sortOrder) => {
      const monthMap = {};
      (arr || []).forEach((item) => {
        if (item && item.monthYear) {
          monthMap[item.monthYear] = item;
        }
      });

      return sortOrder.map((month) =>
        monthMap[month] ? monthMap[month] : { expense: "", monthYear: month },
      );
    };

    // Function to update revenue data for subcontractor
    const updateSubcontractorRevenueData = (psrDetailList, sortOrder) => {
      return psrDetailList.map((item) => {
        const updatedItem = { ...item };

        const headerLength = psrHeaders ? psrHeaders.length + 5 : 0; // Adjust based on your specific requirements
        let rearrangedMonthDetail = mapBySortOrder(
          item.monthExpenseDetail || [],
          sortOrder,
        );

        if (rearrangedMonthDetail.length < headerLength) {
          const defaultMonthItems = Array(
            headerLength - rearrangedMonthDetail.length,
          )
            .fill()
            .map(() => ({ expense: "" }));
          rearrangedMonthDetail.push(...defaultMonthItems);
        } else if (rearrangedMonthDetail.length > headerLength) {
          rearrangedMonthDetail = rearrangedMonthDetail.slice(0, headerLength);
        }

        updatedItem.monthExpenseDetail = rearrangedMonthDetail;
        return updatedItem;
      });
    };

    // Function to update totalPsr data for subcontractor
    const updateSubcontractorTotalPsr = (totalPsr, sortOrder) => {
      const headerLength = psrHeaders ? psrHeaders.length + 5 : 5;
      let mapped = mapBySortOrder(totalPsr || [], sortOrder);

      if (mapped.length < headerLength) {
        const defaultMonthItems = Array(headerLength - mapped.length)
          .fill()
          .map(() => ({ expense: "" }));
        mapped.push(...defaultMonthItems);
      } else if (mapped.length > headerLength) {
        mapped = mapped.slice(0, headerLength);
      }

      return mapped;
    };

    // Call the functions
    const updatedRevenueData = updateSubcontractorRevenueData(
      filteredSubcontractor,
      sortOrder,
    );
    const updatedTotalPsr = updateSubcontractorTotalPsr(
      subcontractorBind.totalSubContractorCost.monthExpenseDetail,
      sortOrder,
    );

    return (
      <Box>
        <Box display="flex" flexDirection="row">
          <Box
            style={{
              boxShadow: "0px 3px 6px #00000029",
              width: "500px",
              marginRight: "8px",
            }}
          >
            <table className="firstTableFin" cellPadding={0} cellSpacing={0}>
              <tbody>
                {filteredSubcontractor.map((item, i) => (
                  <tr key={i}>
                    <td
                      style={{ minWidth: "270px", maxWidth: "270px" }}
                      title={item.project}
                    >
                      {item.project}
                    </td>
                    <td
                      style={{ minWidth: "230px", maxWidth: "230px" }}
                      title={item.projectName}
                    >
                      {item.projectName}
                    </td>
                  </tr>
                ))}

                <tr>
                  <td
                    colSpan={6}
                    style={{
                      textAlign: "right",
                      fontWeight: 600,
                      paddingRight: "8px",
                    }}
                  >
                    Total Subcontractor
                  </td>
                </tr>
              </tbody>
            </table>
          </Box>
          <Box
            ref={subcontractorRef}
            style={{ overflowX: "auto", boxShadow: "0px 3px 6px #00000029" }}
            onScroll={() => handleScrollTable("subcontractor")}
          >
            <Box display="flex" flexDirection="row">
              <Box
                style={{
                  boxShadow: "0px 3px 6px #00000029",
                  marginRight: "8px",
                }}
              >
                <table
                  className="secondTableFin"
                  cellPadding={0}
                  cellSpacing={0}
                  width={"1500"}
                >
                  <tbody>
                    {updatedRevenueData.map((item, i) => (
                      <tr key={i}>
                        {item.monthExpenseDetail.map((monthItem, j) => (
                          <>
                            <td
                              style={{
                                minWidth: "120px",
                                maxWidth: "120px",
                                textAlign: "center",
                              }}
                              title={monthItem.expense}
                            >
                              {monthItem.expense === ""
                                ? ""
                                : `${convertValuesFM(monthItem.expense)}`}
                            </td>
                          </>
                        ))}
                      </tr>
                    ))}
                    <tr className="totalDataRow">
                      {updatedTotalPsr.map((item, i) => (
                        <>
                          <td
                            style={{
                              minWidth: "120px",
                              maxWidth: "120px",
                              textAlign: "center",
                            }}
                            title={item.expense}
                          >
                            {item.expense === ""
                              ? ""
                              : `${convertValuesFM(item.expense)}`}
                          </td>
                        </>
                      ))}
                    </tr>
                  </tbody>
                </table>
              </Box>
            </Box>
          </Box>
        </Box>

        <PaginationData
          data={subcontractorBind.psrClinData || []}
          setFilteredData={setFilteredSubcontractor}
          title="SUBCONTRACTOR"
        />
      </Box>
    );
  } else {
    return (
      <div
        style={{
          textAlign: "center",
          fontWeight: 600,
          background: "#fff",
          padding: "24px 0",
        }}
      >
        No Data
      </div>
    );
  }
};
export const bindOtherDirectCosts = ({
  otherdirectcostsBind,
  psrHeaders,
  handleScrollTable,
  otherdirectcostsRef,
  sortOrder,
  filteredOtherDirectCost,
  setFilteredOtherDirectCost,
}) => {
  if (
    otherdirectcostsBind &&
    otherdirectcostsBind.psrClinData &&
    otherdirectcostsBind.psrClinData.length > 0
  ) {
    const monthsHeader = [];

    psrHeaders?.map((res) => {
      monthsHeader.push(res);
    });

    // Utility function to align by sortOrder and fill missing months
    const mapBySortOrder = (arr, sortOrder) => {
      const monthMap = {};
      (arr || []).forEach((item) => {
        if (item && item.monthYear) {
          monthMap[item.monthYear] = item;
        }
      });

      return sortOrder.map((month) =>
        monthMap[month] ? monthMap[month] : { expense: "", monthYear: month },
      );
    };

    // Function to update revenue data for other direct costs
    const updateOtherDirectCostsRevenueData = (psrDetailList, sortOrder) => {
      return psrDetailList.map((item) => {
        const updatedItem = { ...item };

        const headerLength = psrHeaders ? psrHeaders.length + 5 : 5; // Adjust this based on your specific requirements
        let rearrangedMonthDetail = mapBySortOrder(
          item.monthExpenseDetail || [],
          sortOrder,
        );

        if (rearrangedMonthDetail.length < headerLength) {
          const defaultMonthItems = Array(
            headerLength - rearrangedMonthDetail.length,
          )
            .fill()
            .map(() => ({ expense: "" }));
          rearrangedMonthDetail.push(...defaultMonthItems);
        } else if (rearrangedMonthDetail.length > headerLength) {
          rearrangedMonthDetail = rearrangedMonthDetail.slice(0, headerLength);
        }

        updatedItem.monthExpenseDetail = rearrangedMonthDetail;
        return updatedItem;
      });
    };

    // Function to update totalPsr data for other direct costs
    const updateOtherDirectCostsTotalPsr = (totalPsr, sortOrder) => {
      const headerLength = psrHeaders ? psrHeaders.length + 5 : 5;
      let mapped = mapBySortOrder(totalPsr || [], sortOrder);

      if (mapped.length < headerLength) {
        const defaultMonthItems = Array(headerLength - mapped.length)
          .fill()
          .map(() => ({ expense: "" }));
        mapped.push(...defaultMonthItems);
      } else if (mapped.length > headerLength) {
        mapped = mapped.slice(0, headerLength);
      }

      return mapped;
    };

    // Call the updated functions
    const updatedRevenueData = updateOtherDirectCostsRevenueData(
      filteredOtherDirectCost,
      sortOrder,
    );
    const updatedTotalPsr = updateOtherDirectCostsTotalPsr(
      otherdirectcostsBind.totalOtherDirectCost.monthExpenseDetail,
      sortOrder,
    );

    return (
      <Box>
        <Box display="flex" flexDirection="row">
          <Box
            style={{
              boxShadow: "0px 3px 6px #00000029",
              width: "500px",
              marginRight: "8px",
            }}
          >
            <table className="firstTableFin" cellPadding={0} cellSpacing={0}>
              <tbody>
                {filteredOtherDirectCost.map((item, i) => (
                  <tr key={i}>
                    <td
                      style={{ minWidth: "270px", maxWidth: "270px" }}
                      title={item.project}
                    >
                      {item.project}
                    </td>
                    <td
                      style={{ minWidth: "230px", maxWidth: "230px" }}
                      title={item.projectName}
                    >
                      {item.projectName}
                    </td>
                  </tr>
                ))}

                <tr>
                  <td
                    colSpan={6}
                    style={{
                      textAlign: "right",
                      fontWeight: 600,
                      paddingRight: "8px",
                    }}
                  >
                    Total Other Direct Costs
                  </td>
                </tr>
              </tbody>
            </table>
          </Box>
          <Box
            ref={otherdirectcostsRef}
            style={{ overflowX: "auto", boxShadow: "0px 3px 6px #00000029" }}
            onScroll={() => handleScrollTable("otherdirectcosts")}
          >
            <Box display="flex" flexDirection="row">
              <Box
                style={{
                  boxShadow: "0px 3px 6px #00000029",
                  marginRight: "8px",
                }}
              >
                <table
                  className="secondTableFin"
                  cellPadding={0}
                  cellSpacing={0}
                  width={"1500"}
                  style={{
                    // width: "100%", // Ensure the table takes the full width
                    tableLayout: "fixed", // Fixed layout for consistent column widths
                  }}
                >
                  <tbody>
                    {updatedRevenueData.map((item, i) => (
                      <tr key={i}>
                        {item.monthExpenseDetail.map((monthItem, j) => (
                          <>
                            <td
                              style={{
                                width: "120px",
                                textAlign: "center",
                              }}
                              title={monthItem.expense}
                            >
                              {monthItem.expense === ""
                                ? ""
                                : `${convertValuesFM(monthItem.expense)}`}
                            </td>
                          </>
                        ))}
                      </tr>
                    ))}
                    <tr className="totalDataRow">
                      {updatedTotalPsr.map((item, i) => (
                        <>
                          <td
                            style={{
                              width: "120px",

                              textAlign: "center",
                            }}
                            title={item.expense}
                          >
                            {item.expense === ""
                              ? ""
                              : `${convertValuesFM(item.expense)}`}
                          </td>
                        </>
                      ))}
                    </tr>
                  </tbody>
                </table>
              </Box>
            </Box>
          </Box>
        </Box>
        <PaginationData
          data={otherdirectcostsBind.psrClinData || []}
          setFilteredData={setFilteredOtherDirectCost}
          title="OTHER DIRECT COSTS"
        />
      </Box>
    );
  } else {
    return (
      <div
        style={{
          textAlign: "center",
          fontWeight: 600,
          background: "#fff",
          padding: "24px 0",
        }}
      >
        No Data
      </div>
    );
  }
};
export const bindTotaDirectCosts = ({
  rearrangeArray,
  otherdirectcostsBind,
  psrHeaders,
  handleScrollTable,
  totaldirectcostsRef,
  sortOrder,
}) => {
  if (otherdirectcostsBind) {
    // Define the sorting order for months and other types.

    // Utility to align array with sortOrder, filling missing months
    const mapBySortOrder = (arr, sortOrder, defaultKey = "expense") => {
      const monthMap = {};
      (arr || []).forEach((item) => {
        if (item?.monthYear) {
          monthMap[item.monthYear] = item;
        }
      });

      return sortOrder.map((month) =>
        monthMap[month]
          ? monthMap[month]
          : { [defaultKey]: "", monthYear: month },
      );
    };

    // Filter unique items by monthYear and type
    const handleData = (data, type) => {
      const uniqueData = data.filter((value, index, self) => {
        return (
          index ===
          self.findIndex(
            (t) => t.monthYear === value.monthYear && t.type === value.type,
          )
        );
      });

      return uniqueData;
    };

    const headerLength = psrHeaders ? psrHeaders.length + 5 : 5;

    // 1. totalDirectLaborCostDetail
    let updatedtotalDirectLaborCostDetail = mapBySortOrder(
      rearrangeArray(otherdirectcostsBind.totalDirectCost.monthExpenseDetail),
      sortOrder,
      "expense",
    );

    if (updatedtotalDirectLaborCostDetail.length < headerLength) {
      const defaultMonthItems = Array(
        headerLength - updatedtotalDirectLaborCostDetail.length,
      )
        .fill()
        .map(() => ({ expense: "" }));
      updatedtotalDirectLaborCostDetail.push(...defaultMonthItems);
    } else if (updatedtotalDirectLaborCostDetail.length > headerLength) {
      updatedtotalDirectLaborCostDetail =
        updatedtotalDirectLaborCostDetail.slice(0, headerLength);
    }

    // 2. grossProfit
    let updatedgrossProfit = mapBySortOrder(
      handleData(
        rearrangeArray(otherdirectcostsBind.grossProfit.monthExpenseDetail),
        "Gross Profit",
      ),
      sortOrder,
      "expense",
    );

    if (updatedgrossProfit.length < headerLength) {
      const defaultMonthItems = Array(headerLength - updatedgrossProfit.length)
        .fill()
        .map(() => ({ expense: "" }));
      updatedgrossProfit.push(...defaultMonthItems);
    } else if (updatedgrossProfit.length > headerLength) {
      updatedgrossProfit = updatedgrossProfit.slice(0, headerLength);
    }

    // 3. grossProfitPercentage
    let updatedgrossProfitPercentage = mapBySortOrder(
      handleData(
        rearrangeArray(
          otherdirectcostsBind.grossProfitPercent.monthExpenseDetail,
        ),
        "Gross Profit Percentage",
      ),
      sortOrder,
      "expense",
    );

    if (updatedgrossProfitPercentage.length < headerLength) {
      const defaultMonthItems = Array(
        headerLength - updatedgrossProfitPercentage.length,
      )
        .fill()
        .map(() => ({ expense: "" }));
      updatedgrossProfitPercentage.push(...defaultMonthItems);
    } else if (updatedgrossProfitPercentage.length > headerLength) {
      updatedgrossProfitPercentage = updatedgrossProfitPercentage.slice(
        0,
        headerLength,
      );
    }

    return (
      <Box display="flex" flexDirection="row">
        <Box
          style={{
            boxShadow: "0px 3px 6px #00000029",
            width: "500px",
            marginRight: "8px",
          }}
        >
          <table className="firstTableFin" cellPadding={0} cellSpacing={0}>
            <tbody>
              <tr>
                <td
                  colSpan={6}
                  style={{
                    textAlign: "right",
                    fontWeight: 600,
                    paddingRight: "8px",
                    minWidth: "500px",
                    maxWidth: "500px",
                  }}
                >
                  Total Direct Cost
                </td>
              </tr>
              <tr>
                <td
                  colSpan={6}
                  style={{
                    textAlign: "right",
                    fontWeight: 600,
                    paddingRight: "8px",
                  }}
                >
                  Gross Profit
                </td>
              </tr>
              <tr>
                <td
                  colSpan={6}
                  style={{
                    textAlign: "right",
                    fontWeight: 600,
                    paddingRight: "8px",
                  }}
                >
                  Gross Margin %
                </td>
              </tr>
            </tbody>
          </table>
        </Box>
        <Box
          ref={totaldirectcostsRef}
          style={{ overflowX: "auto", boxShadow: "0px 3px 6px #00000029" }}
          onScroll={() => handleScrollTable("totaldirectcosts")}
        >
          <Box display="flex" flexDirection="row">
            <Box
              style={{
                boxShadow: "0px 3px 6px #00000029",
                marginRight: "8px",
              }}
            >
              <table
                className="secondTableFin"
                cellPadding={0}
                cellSpacing={0}
                width={"1500"}
                style={{
                  // width: "100%", // Ensure the table takes the full width
                  tableLayout: "fixed", // Fixed layout for consistent column widths
                }}
              >
                <tbody>
                  <tr className="totalDataRow">
                    {updatedtotalDirectLaborCostDetail.map((item, i) => (
                      <td
                        key={i}
                        style={{
                          width: "120px",
                          textAlign: "center",
                        }}
                        width={115}
                        title={item.expense}
                      >
                        {item.expense === ""
                          ? ""
                          : `${convertValuesFM(item.expense)}`}
                      </td>
                    ))}
                  </tr>
                  <tr className="totalDataRow">
                    {updatedgrossProfit.map((item, i) => (
                      <td
                        key={i}
                        style={{
                          width: "120px",
                          textAlign: "center",
                        }}
                        title={item.expense}
                      >
                        {item.expense === ""
                          ? ""
                          : `${convertValuesFM(item.expense)}`}
                      </td>
                    ))}
                  </tr>
                  <tr className="totalDataRow">
                    {updatedgrossProfitPercentage.map((item, i) => (
                      <td
                        key={i}
                        style={{
                          width: "120px",
                          textAlign: "center",
                        }}
                        title={item.expense}
                      >
                        {item.expense < 0
                          ? `(${Math.abs(item.expense).toFixed(2)}%)`
                          : `${
                              item.expense !== ""
                                ? Number(item.expense).toFixed(2)
                                : ""
                            }${item.expense === "" ? "" : "%"}`}
                      </td>
                    ))}
                  </tr>
                </tbody>
              </table>
            </Box>
          </Box>
        </Box>
      </Box>
    );
  } else {
    return (
      <div
        style={{
          textAlign: "center",
          fontWeight: 600,
          background: "#fff",
          padding: "24px 0",
        }}
      >
        No Data
      </div>
    );
  }
};
export const bindInDirectCosts = ({
  indirectCostsBind,
  psrHeaders,
  handleScrollTable,
  indirectCostsRef,
  sortOrder,
  classes,
  isEditing,
  handleVarianceChange,
  onAddNew,
}) => {
  if (!indirectCostsBind?.psrClinData) return null;

  const monthsHeader = psrHeaders || [];
  const headerLength = psrHeaders ? psrHeaders.length + 5 : 5;

  const mapBySortOrder = (arr) => {
    const monthMap = {};
    (arr || []).forEach((item) => {
      if (item?.monthYear) monthMap[item.monthYear] = item;
    });
    let aligned = sortOrder.map((month) =>
      monthMap[month] ? monthMap[month] : { expense: "", monthYear: month },
    );
    if (aligned.length < headerLength) {
      aligned = [
        ...aligned,
        ...Array(headerLength - aligned.length)
          .fill()
          .map(() => ({ expense: "" })),
      ];
    } else if (aligned.length > headerLength) {
      aligned = aligned.slice(0, headerLength);
    }
    return aligned;
  };

  // Use full data directly — no pagination
  const updatedClinData = Object.values(indirectCostsBind.psrClinData).map(
    (item) => ({
      ...item,
      fringe: mapBySortOrder(item.monthExpenseDetail || []),
    }),
  );

  return (
    <Box>
      <Box display="flex" flexDirection="row">
        {/* Left fixed table */}
        <Box
          style={{
            boxShadow: "0px 3px 6px #00000029",
            width: "500px",
            marginRight: "8px",
          }}
        >
          <table className="firstTableFin" cellPadding={0} cellSpacing={0}>
            <thead>
              <tr>
                <th style={{ minWidth: "270px", maxWidth: "270px" }}>
                  Project
                </th>
                <th style={{ minWidth: "230px", maxWidth: "230px" }}>
                  Project Name
                </th>
              </tr>
            </thead>
            <tbody>
              {updatedClinData.map((item, i) => (
                <tr key={i}>
                  <td
                    style={{ minWidth: "270px", maxWidth: "270px" }}
                    title={item.project}
                  >
                    {item.project?.toUpperCase()}
                  </td>
                  <td
                    style={{ minWidth: "230px", maxWidth: "230px" }}
                    title={item.projectName}
                  >
                    {item.projectName?.toUpperCase()}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </Box>

        {/* Right scrollable table */}
        <Box
          ref={indirectCostsRef}
          style={{ overflowX: "auto", boxShadow: "0px 3px 6px #00000029" }}
          onScroll={() => handleScrollTable("indirectCosts")}
        >
          <table
            className="secondTableFin"
            cellPadding={0}
            cellSpacing={0}
            width={"1500"}
          >
            <thead>
              <tr>
                {[1, 2, 3, 4, 5].map((_, i) => (
                  <th
                    key={i}
                    rowSpan={1}
                    style={{ minWidth: "120px", maxWidth: "120px" }}
                  ></th>
                ))}
                {monthsHeader.map((item, i) => (
                  <th
                    key={i}
                    rowSpan={1}
                    className="centerAlignedHeaderLeftBorder"
                    style={{
                      minWidth: "100px",
                      maxWidth: "100px",
                      padding: "0px 10px",
                      textAlign: "center",
                    }}
                  >
                    {item.heading}
                  </th>
                ))}
              </tr>
              <tr>
                <th
                  rowSpan={1}
                  style={{
                    minWidth: "120px",
                    maxWidth: "120px",
                    padding: "0px 20px",
                    textAlign: "center",
                  }}
                  className="actualHeaderCost"
                >
                  ITD Actuals till 2024
                </th>
                <th
                  rowSpan={1}
                  style={{
                    minWidth: "120px",
                    maxWidth: "120px",
                    padding: "0px 10px",
                    textAlign: "center",
                  }}
                  className="actualHeaderCost"
                >
                  ITD Actuals from 2025
                </th>
                <th
                  rowSpan={1}
                  style={{
                    minWidth: "120px",
                    maxWidth: "120px",
                    padding: "0px 10px",
                    textAlign: "center",
                  }}
                  className="forecastHeaderCost"
                >
                  Forecast (ETC)
                </th>
                <th
                  rowSpan={1}
                  style={{
                    minWidth: "120px",
                    maxWidth: "120px",
                    padding: "0px 10px",
                    textAlign: "center",
                  }}
                  className="actualHeaderCost"
                >
                  Actuals + Forecast (EAC)
                </th>
                <th
                  rowSpan={1}
                  style={{
                    minWidth: "120px",
                    maxWidth: "120px",
                    padding: "0px 10px",
                    textAlign: "center",
                  }}
                  className="forecastHeaderCost"
                >
                  Total for Year
                </th>
                {monthsHeader.map((item, i) => (
                  <th
                    key={i}
                    rowSpan={1}
                    className={
                      item.type === "Actual"
                        ? "actualHeaderCost"
                        : "forecastHeaderCost"
                    }
                    style={{
                      minWidth: "100px",
                      maxWidth: "100px",
                      padding: "0px 10px",
                      textAlign: "center",
                    }}
                  >
                    {item.type}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {updatedClinData.map((item, i) => (
                <tr key={i}>
                  {item.fringe.map((monthItem, j) => (
                    <td
                      key={j}
                      style={{
                        minWidth: "120px",
                        maxWidth: "120px",
                        textAlign: "center",
                      }}
                      title={monthItem.expense}
                    >
                      {monthItem.expense === ""
                        ? ""
                        : `${convertValuesFM(monthItem.expense)}`}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </Box>
      </Box>
    </Box>
  );
};

export const bindInDirectVariance = ({
  indirectCostsBind,
  psrHeaders,
  handleScrollTable,
  indirectVarianceRef,
  sortOrder,
  classes,
  isEditing,
  handleVarianceChange,
  filteredIndirectVariance,
  setFilteredIndirectVariance,
}) => {
  const varianceList = indirectCostsBind?.psrIndirectVarianceList || [];
  if (!varianceList.length) return null;

  const monthsHeader = psrHeaders || [];
  const headerLength = psrHeaders ? psrHeaders.length + 5 : 5;

  const mapBySortOrder = (arr) => {
    const monthMap = {};
    (arr || []).forEach((item) => {
      if (item?.monthYear) monthMap[item.monthYear] = item;
    });
    let aligned = sortOrder.map((month) =>
      monthMap[month] ? monthMap[month] : { expense: "", monthYear: month },
    );
    if (aligned.length < headerLength) {
      aligned = [
        ...aligned,
        ...Array(headerLength - aligned.length)
          .fill()
          .map(() => ({ expense: "" })),
      ];
    } else if (aligned.length > headerLength) {
      aligned = aligned.slice(0, headerLength);
    }
    return aligned;
  };

  const updatedVarianceList = (
    filteredIndirectVariance.length ? filteredIndirectVariance : varianceList
  ).map((item) => ({
    ...item,
    fringe: mapBySortOrder(item.monthExpenseDetail || []),
  }));

  return (
    <Box>
      <Box display="flex" flexDirection="row" style={{ marginTop: "8px" }}>
        <Box
          style={{
            boxShadow: "0px 3px 6px #00000029",
            width: "500px",
            marginRight: "8px",
          }}
        >
          <table className="firstTableFin" cellPadding={0} cellSpacing={0}>
            <tbody>
              {updatedVarianceList.map((item, i) => (
                <tr key={`variance-left-${i}`}>
                  <td
                    style={{ minWidth: "270px", maxWidth: "270px" }}
                    title={item.projectName || item.project}
                  >
                    {item.project}
                  </td>
                  <td
                    style={{ minWidth: "230px", maxWidth: "230px" }}
                    title={item.projectName || item.project}
                  >
                    {item.projectName}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </Box>
        <Box
          ref={indirectVarianceRef}
          style={{ overflowX: "auto", boxShadow: "0px 3px 6px #00000029" }}
          onScroll={() => handleScrollTable("indirectVariance")}
        >
          <table
            className="secondTableFin"
            cellPadding={0}
            cellSpacing={0}
            width={"1500"}
          >
            <tbody>
              {updatedVarianceList.map((item, i) => (
                <tr key={`variance-row-${i}`}>
                  {item.fringe.map((monthItem, j) => {
                    const isDecCol = j === headerLength - 1;
                    return (
                      <td
                        key={j}
                        style={{
                          minWidth: "120px",
                          maxWidth: "120px",
                          textAlign: "center",
                        }}
                        title={monthItem.expense}
                      >
                        {isDecCol && isEditing ? (
                          <input
                            type="number"
                            className={classes?.inputStyle}
                            defaultValue={monthItem.expense ?? ""}
                            onChange={(e) =>
                              handleVarianceChange(
                                item.originalIndex ?? i,
                                e.target.value,
                              )
                            }
                          />
                        ) : monthItem.expense === "" ||
                          monthItem.expense == null ? (
                          ""
                        ) : (
                          convertValuesFM(monthItem.expense)
                        )}
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </Box>
      </Box>

      <PaginationData
        data={varianceList}
        setFilteredData={setFilteredIndirectVariance}
        title="INDIRECT VARIANCE"
        search=""
        searchLcat=""
      />
    </Box>
  );
};

export const bindInDirectTotal = ({
  indirectCostsBind,
  psrHeaders,
  handleScrollTable,
  indirectTotalRef,
  sortOrder,
}) => {
  if (!indirectCostsBind?.totalIndirectCost) return null;

  const monthsHeader = psrHeaders || [];
  const headerLength = psrHeaders ? psrHeaders.length + 5 : 5;

  const mapBySortOrder = (arr) => {
    const monthMap = {};
    (arr || []).forEach((item) => {
      if (item?.monthYear) monthMap[item.monthYear] = item;
    });
    let aligned = sortOrder.map((month) =>
      monthMap[month] ? monthMap[month] : { expense: "", monthYear: month },
    );
    if (aligned.length < headerLength) {
      aligned = [
        ...aligned,
        ...Array(headerLength - aligned.length)
          .fill()
          .map(() => ({ expense: "" })),
      ];
    } else if (aligned.length > headerLength) {
      aligned = aligned.slice(0, headerLength);
    }
    return aligned;
  };

  const updatedTotalPsr = mapBySortOrder(
    indirectCostsBind.totalIndirectCost?.monthExpenseDetail || [],
  );

  return (
    <Box display="flex" flexDirection="row" style={{ marginTop: "8px" }}>
      <Box
        style={{
          boxShadow: "0px 3px 6px #00000029",
          width: "500px",
          marginRight: "8px",
        }}
      >
        <table className="firstTableFin" cellPadding={0} cellSpacing={0}>
          <tbody>
            <tr>
              <td style={{ minWidth: "270px", maxWidth: "270px" }}></td>
              <td
                colSpan={2}
                style={{
                  textAlign: "right",
                  fontWeight: 600,
                  paddingRight: "8px",
                  minWidth: "230px",
                  maxWidth: "230px",
                }}
              >
                Total Indirect Costs
              </td>
            </tr>
          </tbody>
        </table>
      </Box>

      <Box
        ref={indirectTotalRef}
        style={{ overflowX: "auto", boxShadow: "0px 3px 6px #00000029" }}
        onScroll={() => handleScrollTable("indirectTotal")}
      >
        <table
          className="secondTableFin"
          cellPadding={0}
          cellSpacing={0}
          width={"1500"}
        >
          <tbody>
            <tr className="totalDataRow">
              {updatedTotalPsr.map((item, i) => (
                <td
                  key={i}
                  style={{
                    minWidth: "120px",
                    maxWidth: "120px",
                    textAlign: "center",
                  }}
                  title={item.expense}
                >
                  {item.expense === ""
                    ? ""
                    : `${convertValuesFM(item.expense)}`}
                </td>
              ))}
            </tr>
          </tbody>
        </table>
      </Box>
    </Box>
  );
};
export const bindTotaInDirectCosts = ({
  rearrangeArray,
  indirectCostsBind,
  psrHeaders,
  handleScrollTable,
  totalindirectcostsRef,
  sortOrder,
}) => {
  if (indirectCostsBind && indirectCostsBind.psrClinData) {
    const monthsHeader = [];
    psrHeaders?.map((res) => {
      monthsHeader.push(res);
    });

    // Generic utility to align data with sortOrder
    const mapBySortOrder = (arr, sortOrder, defaultKey = "expense") => {
      const monthMap = {};
      (arr || []).forEach((item) => {
        if (item && item.monthYear) {
          monthMap[item.monthYear] = item;
        }
      });

      return sortOrder.map((month) =>
        monthMap[month]
          ? monthMap[month]
          : { [defaultKey]: "", monthYear: month },
      );
    };

    const headerLength = psrHeaders ? psrHeaders.length + 5 : 5;

    // 1. Update totalDirectLaborCostDetail (burden)
    let updatedtotalDirectLaborCostDetail = mapBySortOrder(
      rearrangeArray(indirectCostsBind.totalCost.monthExpenseDetail),
      sortOrder,
      "expense",
    );

    if (updatedtotalDirectLaborCostDetail.length < headerLength) {
      const defaultMonthItems = Array(
        headerLength - updatedtotalDirectLaborCostDetail.length,
      )
        .fill()
        .map(() => ({ expense: " " }));
      updatedtotalDirectLaborCostDetail.push(...defaultMonthItems);
    } else if (updatedtotalDirectLaborCostDetail.length > headerLength) {
      updatedtotalDirectLaborCostDetail =
        updatedtotalDirectLaborCostDetail.slice(0, headerLength);
    }

    // 2. Update forecastCostAdjustment
    let updatedAdjustedCostDetail = mapBySortOrder(
      rearrangeArray(
        indirectCostsBind.forecastCostAdjustment.monthExpenseDetail,
      ),
      sortOrder,
      "expense",
    );

    if (updatedAdjustedCostDetail.length < headerLength) {
      const defaultMonthItems = Array(
        headerLength - updatedAdjustedCostDetail.length,
      )
        .fill()
        .map(() => ({ expense: " " }));
      updatedAdjustedCostDetail.push(...defaultMonthItems);
    } else if (updatedAdjustedCostDetail.length > headerLength) {
      updatedAdjustedCostDetail = updatedAdjustedCostDetail.slice(
        0,
        headerLength,
      );
    }

    // 3. Update grossProfit (netProfit)
    let updatedgrossProfit = mapBySortOrder(
      rearrangeArray(indirectCostsBind.netProfit.monthExpenseDetail),
      sortOrder,
      "expense",
    );

    if (updatedgrossProfit.length < headerLength) {
      const defaultMonthItems = Array(headerLength - updatedgrossProfit.length)
        .fill()
        .map(() => ({ expense: " " }));
      updatedgrossProfit.push(...defaultMonthItems);
    } else if (updatedgrossProfit.length > headerLength) {
      updatedgrossProfit = updatedgrossProfit.slice(0, headerLength);
    }

    // 4. Update grossProfitPercentage (netMargin)
    let updatedgrossProfitPercentage = mapBySortOrder(
      rearrangeArray(indirectCostsBind.netProfitPercent.monthExpenseDetail),
      sortOrder,
      "expense",
    );

    if (updatedgrossProfitPercentage.length < headerLength) {
      const defaultMonthItems = Array(
        headerLength - updatedgrossProfitPercentage.length,
      )
        .fill()
        .map(() => ({ expense: " " }));
      updatedgrossProfitPercentage.push(...defaultMonthItems);
    } else if (updatedgrossProfitPercentage.length > headerLength) {
      updatedgrossProfitPercentage = updatedgrossProfitPercentage.slice(
        0,
        headerLength,
      );
    }

    return (
      <Box display="flex" flexDirection="row">
        <Box
          style={{
            boxShadow: "0px 3px 6px #00000029",
            width: "500px",
            marginRight: "8px",
          }}
        >
          <table className="firstTableFin" cellPadding={0} cellSpacing={0}>
            <tbody>
              <tr>
                <td
                  colSpan={6}
                  style={{
                    textAlign: "right",
                    fontWeight: 600,
                    paddingRight: "8px",
                    minWidth: "500px",
                    maxWidth: "500px",
                  }}
                >
                  Forecast Adjustment
                </td>
              </tr>
              <tr>
                <td
                  colSpan={6}
                  style={{
                    textAlign: "right",
                    fontWeight: 600,
                    paddingRight: "8px",
                    minWidth: "500px",
                    maxWidth: "500px",
                  }}
                >
                  Total Cost
                </td>
              </tr>
              <tr>
                <td
                  colSpan={6}
                  style={{
                    textAlign: "right",
                    fontWeight: 600,
                    paddingRight: "8px",
                  }}
                >
                  Net Profit / Fee
                </td>
              </tr>
              <tr>
                <td
                  colSpan={6}
                  style={{
                    textAlign: "right",
                    fontWeight: 600,
                    paddingRight: "8px",
                  }}
                >
                  Net Margin %
                </td>
              </tr>
            </tbody>
          </table>
        </Box>
        <Box
          ref={totalindirectcostsRef}
          style={{ overflowX: "auto", boxShadow: "0px 3px 6px #00000029" }}
          onScroll={() => handleScrollTable("totalindirectcosts")}
        >
          <Box display="flex" flexDirection="row">
            <Box
              style={{
                boxShadow: "0px 3px 6px #00000029",
                marginRight: "8px",
              }}
            >
              <table
                className="secondTableFin"
                cellPadding={0}
                cellSpacing={0}
                width={1500} // Ensure table spans full width
                style={{
                  tableLayout: "fixed", // Fixed layout to enforce column width
                }}
              >
                <tbody>
                  <tr className="totalDataRow">
                    {updatedAdjustedCostDetail.map((item, i) => (
                      <>
                        <td
                          style={{
                            width: "120px", // Fixed width
                            textAlign: "center",
                            wordWrap: "break-word", // Wrap text if it's too long
                            overflow: "hidden", // Ensure content doesn't overflow
                            textOverflow: "ellipsis", // Truncate overflowing content
                            boxSizing: "border-box",
                          }}
                          title={item.expense}
                        >
                          {item.expense === ""
                            ? ""
                            : `${convertValuesFM(item.expense)}`}
                        </td>
                      </>
                    ))}
                  </tr>
                  <tr className="totalDataRow">
                    {updatedtotalDirectLaborCostDetail.map((item, i) => (
                      <>
                        <td
                          style={{
                            width: "120px", // Fixed width
                            textAlign: "center",
                            wordWrap: "break-word", // Wrap text if it's too long
                            overflow: "hidden", // Ensure content doesn't overflow
                            textOverflow: "ellipsis", // Truncate overflowing content
                            boxSizing: "border-box",
                          }}
                          title={item.expense}
                        >
                          {item.expense === ""
                            ? ""
                            : `${convertValuesFM(item.expense)}`}
                        </td>
                      </>
                    ))}
                  </tr>

                  <tr className="totalDataRow">
                    {updatedgrossProfit.map((item, i) => (
                      <>
                        <td
                          style={{
                            width: "120px", // Fixed width
                            textAlign: "center",
                            wordWrap: "break-word", // Wrap text if it's too long
                            overflow: "hidden", // Ensure content doesn't overflow
                            textOverflow: "ellipsis", // Truncate overflowing content
                            boxSizing: "border-box",
                          }}
                          title={item.expense}
                        >
                          {item.expense === ""
                            ? ""
                            : `${convertValuesFM(item.expense)}`}
                        </td>
                      </>
                    ))}
                  </tr>
                  <tr className="totalDataRow">
                    {updatedgrossProfitPercentage.map((item, i) => (
                      <>
                        <td
                          style={{
                            width: "120px", // Fixed width
                            textAlign: "center",
                            wordWrap: "break-word", // Wrap text if it's too long
                            overflow: "hidden", // Ensure content doesn't overflow
                            textOverflow: "ellipsis", // Truncate overflowing content
                            boxSizing: "border-box",
                          }}
                          title={item.expense}
                        >
                          {item.expense < 0
                            ? `(${Math.abs(item.expense).toFixed(2)}%)`
                            : `${
                                item.expense !== ""
                                  ? Number(item.expense).toFixed(2)
                                  : ""
                              }${item.expense === "" ? "" : "%"}`}
                        </td>
                      </>
                    ))}
                  </tr>
                </tbody>
              </table>
            </Box>
          </Box>
        </Box>
      </Box>
    );
  } else {
    return (
      <div
        style={{
          textAlign: "center",
          fontWeight: 600,
          background: "#fff",
          padding: "24px 0",
        }}
      >
        No Data
      </div>
    );
  }
};
